import { Button, Divider, Input, Table, Tooltip } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { openPopup2 } from "../../../contexts/PopupContext";
import { selectLocation } from "../../../util/store/location/constants";
import { locationActions } from "../../../util/store/location/reducer";
import { selectRegion } from "../../../util/store/region/constants";
import { selectPermissions } from "../../../util/store/selectors";
import { IPois } from "../../../util/varibles/interface";
import { ACTION } from "../../../util/varibles/permission";
import { ColumnTemplates } from "../../../util/varibles/template";
import styles from "../style.module.scss";
import PopupEdit from "./PopupEdit";

interface IProps {
}

const Pois: React.FC<IProps> = () => {
    const [search, setSearch] = useState('');
    const regions = useSelector(selectRegion.regions);
    const locations = useSelector(selectLocation.data);
    const loading = useSelector(selectLocation.loading);
    const [canUpdateLocation, canDeleteLocation, canCreateLocation] = useSelector(selectPermissions([
        ACTION.LOCATION.UPDATE,
        ACTION.LOCATION.DELETE,
        ACTION.LOCATION.CREATE,
    ]));
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(locationActions.getPois())
    }, [dispatch]);

    const handleKeyDown = useCallback((e: any) => {
        if (e.key === 'Escape')
            setSearch('')
    }, []);

    const handleClick = useCallback((data?: IPois) => {
        openPopup2(<PopupEdit location={data} />, {
            modalProps: {
                className: styles.popupEdit,
                title: data ? 'Update location' : 'New POI location',
                width: 1020,
            }
        })
    }, [])

    const dataSource = useMemo(() => locations.filter(({ name }) => {
        return search.length === 0 || name.toLowerCase().includes(search.trim().toLowerCase())
    }), [locations, search]);

    const isMenu = useMemo(() => canUpdateLocation || canDeleteLocation, [canUpdateLocation, canDeleteLocation]);

    return <div className={styles.content}>
        <div className='flex justify-end mb-10'>
            <Input
                value={search}
                onChange={(e: any) => setSearch(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder='Search by name'
                className={styles.search}
            />
            {canCreateLocation && <>
                <Divider className='divider-vertical' orientation='vertical' />
                <Tooltip title="Add Poi location">
                    <Button className='bt-primary bt-plus' type="primary" shape="circle"
                        onClick={() => handleClick()}
                    />
                </Tooltip>
            </>}
        </div>
        <Table {...{
            rowKey: "id",
            pagination: false,
            columns: [
                ColumnTemplates.Name,
                ColumnTemplates.WorkTime,
                ColumnTemplates.Phone,
                ColumnTemplates.Position,
                ColumnTemplates.Regions(regions),
                {
                    title: 'Capabilities',
                    dataIndex: 'capabilities',
                    key: 'capabilities',
                    render: (data: any) => {
                        if (!Array.isArray(data))
                            return null
                        return data.map(item => item.name).join(', ')
                    },
                },
                ...(isMenu ? [ColumnTemplates.Menu<IPois>(handleClick)] : []),
            ],
            loading,
            dataSource
        }} />
    </div>;
};

export default Pois;
